<template>
    <div class="iframe-container">
        <iframe
            ref="iframe"
            width="100%"
            height="100%"
            class="main-iframe"
            allowfullscreen="true"
            allowtransparency="true"
            allow="
                accelerometer *;
                encrypted-media *;
                gyroscope *;
                midi *;
                clipboard-write *;
                web-share *;
                xr-spatial-tracking *;
                language-detector *;
                translator *;
                summarizer *;
                writer *;
                rewriter *;
                language-model *;
                proofreader *;
                clipboard-read *;
                clipboard-read-text *;
                clipboard-read-image *;
                clipboard-read-audio *;
                clipboard-read-video *;
            "
            :src="iframeSrc"
            :scrolling="iframeScrolling"
        ></iframe>
        <div v-if="showMask" class="iframe-mask" :style="maskStyle"></div>
    </div>
</template>
<script>
const RESIZE_MSG_TYPE = 'fego-iframe-resize';

export default {
    props: {
        iframeSrc: String,
        showMask: Boolean,
        maskBgcolor: String,
        iframeScrolling: String,
        autoResize: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        maskStyle() {
            return { backgroundColor: `${this.maskBgcolor}` };
        }
    },
    methods: {
        onMessage(event) {
            const data = event && event.data;
            if (!data || data.type !== RESIZE_MSG_TYPE) {
                return;
            }
            const iframeEl = this.$refs.iframe;
            if (!iframeEl || event.source !== iframeEl.contentWindow) {
                return;
            }
            const h = Number(data.height);
            if (!Number.isFinite(h) || h <= 0) {
                return;
            }
            this.applyHeight(Math.ceil(h));
        },
        applyHeight(h) {
            // 直接写 inline style, 覆盖 fego 根据 tpl.style.height 套的 wrapper 高度
            // 同时覆盖 $el 自身和外层父 wrapper (fego 框架根据结构不同, 高度可能落在其中之一)
            if (this.$el) {
                this.$el.style.height = `${h}px`;
                const parent = this.$el.parentNode;
                if (parent && parent.nodeType === 1 && parent !== document.body) {
                    parent.style.height = `${h}px`;
                }
            }
        }
    },
    mounted() {
        if (!this.autoResize) {
            return;
        }
        // 编辑器画布是绝对布局, 自适应仅在渲染端生效
        if (!window.FEGORender) {
            return;
        }
        window.addEventListener('message', this.onMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.onMessage);
    }
};
</script>
<style lang="less" scoped>
.iframe-container {
    position: relative;
    .main-iframe {
        display: block;
    }
    .iframe-mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
}
</style>
